// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch__container___7xVnE","iconChecked":"Switch__iconChecked___G1f79","iconUnchecked":"Switch__iconUnchecked___XLLP9"};